/**
 * Created by Administrador on 9/22/2016.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .constant('LANGUAGES', [
                'es',
                'en'
            ]
        );
})();
